import type { FormFieldData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";

export const VERMARKTUNG_CONTRACT_GENERATORS_SELECTION_FIELDS = {
  generators: {
    name: "generators",
    type: "multiselect",
    label: "Erzeuger, die vom kopierten Vertrag übernommen werden sollen"
  }
} as const satisfies FormFieldData<{ generators: number[] }>;
